import { styled } from "@mui/system";
import { GridFilterInputSingleSelect } from "@mui/x-data-grid-premium";
import BryxColors from "../../types/theme";
export const BryxGridFilterInputSingleSelect = styled(GridFilterInputSingleSelect)(({ theme }) => ({
    "&": {
        marginTop: "4px",
        minWidth: "177px",
    },
    "& .MuiFormLabel-root:hover, & .MuiFormLabel-root:has(~ .MuiInputBase-root:hover:not(.Mui-focused):not(.Mui-disabled))": {
        color: `${BryxColors.brand2(theme.palette.mode)} !important`,
    },
    "& .MuiFormLabel-root.Mui-focused": {
        color: BryxColors.brandDark2(theme.palette.mode),
    },
    "& .MuiFormLabel-root": {
        color: BryxColors.notify(theme.palette.mode, "inactive"),
    },
    "& .MuiInputBase-root": {
        marginTop: "28px",
    },
    "& .MuiInputBase-root:hover:not(.Mui-focused):not(.Mui-disabled):before, & .MuiFormLabel-root:hover ~ .MuiInputBase-root:before": {
        borderBottom: `2px solid ${BryxColors.brand2(theme.palette.mode)} !important`,
    },
    "& .MuiInputBase-root:after": {
        borderColor: `${BryxColors.brandDark2(theme.palette.mode)} !important`,
    },
    "& .MuiInputBase-root:before": {
        borderColor: `${BryxColors.specialColor(theme.palette.mode).greyButGray} !important`,
    },
}));
export default BryxGridFilterInputSingleSelect;
